import colorLib from '@kurkle/color'
import { LuneThemeNew } from '@lune-fe/lune-ui-lib'
const { palette } = LuneThemeNew

export const transparentize = (value: string, alpha: number) => {
    const a = 1 - alpha
    return colorLib(value).lighten(a).rgbString()
}

export const getGradient = (ctx: any, chartArea: any, color: string) => {
    const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top)
    gradient.addColorStop(0, palette.WhiteTransparent50)
    gradient.addColorStop(1, transparentize(color, 0.8))
    return gradient
}
